import styled from '@emotion/styled';
import { styled as muiStyled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ViewContainer = styled.div`
  height: 100vh;
  max-height: 100vh;
  padding: 125px 100px 20px 100px;

  @media (max-width: 768px) {
    padding: 125px 50px 20px 50px;
  }
`;

export const Title = muiStyled('div')(({ theme }) => ({
  fontWeight: 700,
  fontSize: '40px',
  marginBottom: '30px',
  fontFamily: 'Space Grotesk',
  color: theme.custom.text,
}));

export const FilterContainer = muiStyled(Box)(({ theme }) => ({
  backgroundColor: theme.custom.background2,
  borderRadius: '10px',
  padding: '20px',
  marginBottom: '20px',
}));

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 20px;

  // Ensure proper spacing for the horizontal scrollbar
  padding-bottom: 5px;

  // Fix for sticky columns
  & .MuiTableContainer-root {
    overflow-x: auto;
    max-width: 100%;
  }
`;

export const CustomFilterContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CustomFilterTitle = muiStyled('div')(({ theme }) => ({
  fontWeight: 700,
  fontFamily: 'Manrope',
  fontSize: '15px',
  marginBottom: '10px',
  color: theme.custom.text,
}));

export const FilterComponentContainer = styled.div`
  margin-bottom: 20px;
`;
